import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { Headerlp } from './header';
import { Pictext } from './pic-text';

import { Join } from './join';
import { Footer } from './footer';
import { Video2 } from './video2';
import { NavBar } from './nav';
import { TheirStories } from "./theirstories";
import styles from './lb.module.css'
import { useCookies } from '../hooks/useCookies';
import { useProfile } from "../components/userflow/components/context/ProfileContext";


export const LP = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);
  const { getCookie } = useCookies();

  const token = getCookie('token')
  const userId = getCookie('userId')
  const { fetchProfile } = useProfile();
   
  const handleRouting = async () => {
    const success = await fetchProfile(); 
    const result = success.data;
  
    if (!success.ok) return;
  
    const routeChecks = [
      { condition: !result?.Birthday, route: "/basicdetails" },
      { condition: !result?.Gender, route: "/abtyourself" },
      { condition: result?.medias?.length === 0, route: "/selfie" },
      { condition: !result?.Country, route: "/located" },
      { condition: !result?.Religion, route: "/religion" },
      { condition:  result?.languages?.length === 0, route: "/religion" },
      { condition: !result?.StudyField, route: "/edu" },
      { condition: !result?.JobTitle, route: "/jobtitle" },
      { condition: !result?.Height, route: "/height" },
      { condition: result?.Personalities?.length === 0, route: "/personality" },
      { condition: result?.question_answers?.length === 0, route: "/profile-answers" },
      { condition: !result?.EmailVerifiedAt, route: "/approve" },
    ];
  
    const nextRoute = routeChecks.find(item => item.condition)?.route;
    navigate(nextRoute || "/user/home");
  };


  useEffect(() => {
    // Redirect to another URL
    if (token && userId) {
      handleRouting()
    }
    else {
      navigate("/");
    }
  }, [token, userId]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobile(true);

    }
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, [])

  return (

    <div className={styles.mainbox}>
      {
        !mobile && <NavBar />
      }

      <Headerlp />
      <Pictext />
      <TheirStories />
      <Video2 />
      <Join />
      <Footer />
    </div>
  );
}

